import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Alert } from 'react-bootstrap';
import { useRecorder } from 'react-microphone-recorder';

function MicRecorder({ onAudioURLChange, showStockButton = false, onShowStock }) {
  const { 
    audioLevel, 
    startRecording, 
    pauseRecording, 
    stopRecording, 
    resetRecording, 
    timeElapsed, 
    audioURL, 
    isRecording 
  } = useRecorder();

  const [micError, setMicError] = useState(null);

  // Update parent component when audioURL changes
  useEffect(() => {
    if (audioURL && typeof onAudioURLChange === 'function') {
      onAudioURLChange(audioURL);
    }
  }, [audioURL, onAudioURLChange]);

  async function toggleRecording() {
    if (isRecording) {
      stopRecording();
    } else {
      try {
        setMicError(null);
        await startRecording();
      } catch (err) {
        setMicError('Microphone access denied. Please allow microphone permission in your browser settings and try again.');
      }
    }
  }

  // Convert the normalized audioLevel (0 - 1) to a percentage (0 - 100)
  const amplitudePercentage = Math.min(audioLevel * 1, 100);

  return (
    <Container className="mt-4">
      {micError && (
        <Alert variant="warning" dismissible onClose={() => setMicError(null)}>
          {micError}
        </Alert>
      )}
      {/* Custom Amplitude Bar */}
      <Row className="mb-3">
        <Col>
          <div
            style={{
              height: '20px',
              backgroundColor: '#eee',
              borderRadius: '10px',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                height: '100%',
                width: `${amplitudePercentage}%`,
                backgroundColor: '#76c7c0',
                transition: 'none',
              }}
            />
          </div>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <div className="d-flex justify-content-between align-items-center desktop-recording-layout">
            <div>
              <Button 
                variant={ isRecording ? "danger" : "primary" }
                onClick={toggleRecording} 
                className="mx-1 btn-voice-recording"
              >
                { isRecording && "Stop Recording" }
                { !isRecording && "Start Recording" }
              </Button>
              
              
            </div>
            <div>
              <p className="mb-0">Recording Time: {timeElapsed}s</p>
            </div>
          </div>
          
          {/* Mobile layout - recording time between buttons */}
          <div className="mobile-recording-layout">
            <div className="d-flex justify-content-center mb-2">
              <Button 
                variant={ isRecording ? "danger" : "primary" }
                onClick={toggleRecording} 
                className="btn-voice-recording"
              >
                { isRecording && "Stop Recording" }
                { !isRecording && "Start Recording" }
              </Button>
            </div>
            
            <div className="text-center mb-2">
              <p className="mb-0">Recording Time: {timeElapsed}s</p>
            </div>
            
            
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default MicRecorder;
